export function isLineItemReplacementEligible(item) {
  return item?.replacement_eligible === true || item?.replacement === true;
}
